import { IUser } from "../models/IUser";
import ApiClient from '../utilities/http';
import * as actionTypes from "../actionsTypes";
import { Endpoints } from "../utilities/endpoints";


export const savePushSubscription = async (user: IUser, subscription?: PushSubscription) => {
    return new Promise(async (resolve, reject) => {
        ApiClient.post(
            Endpoints.PUSH_SUBSCRIPTION, {
            registration: JSON.stringify(subscription),
        })
            .then(res => {
                if (res.status === 200)
                    resolve(true);
            })
            .catch(err => {
                reject(err);
            });
    })
}

export const pushUnsubscribe = (user: IUser) => {
    return {
        type: actionTypes.PUSH_SUBSCRIBED, payload: { push_subscribed: 0 }
    };
}

export const denyNotifications = () => {
    return {
        type: actionTypes.PUSH_SUBSCRIBED, payload: { push_subscribed: -1 }
    }
}
